import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 9.54H6V7.53H18V9.54ZM16 11.55H6V13.56H16V11.55ZM22 5.01V16.08C22 17.19 21.1 18.09 20 18.09H7.1L3.79 20.76C3.59 20.92 3.35 21 3.1 21C2.94 21 2.77 20.96 2.62 20.89C2.24 20.7 2 20.32 2 19.89V5.01C2 3.9 2.9 3 4 3H20C21.1 3 22 3.9 22 5.01ZM20 5.01H4V18.01L6.4 16.08H20V5.01Z" fill={ fill || 'currentColor' } />
    </svg>
);
